import { ModelRow } from "@mcleod/core";
import { DataSourceMode, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutOtherChargeChangeCompareItem } from "./autogen/AutogenLayoutOtherChargeChangeCompareItem";
import { BaseCompare } from "./BaseCompare";

export class OtherChargeChangeCompareItem extends AutogenLayoutOtherChargeChangeCompareItem {

    private _compareItems: ModelRow[];
    private _isCompareHistory: boolean = false;
    private _isOrderUpdateAllowed: boolean = true;
    private baseCompare = new BaseCompare();


    public get isOrderUpdateAllowed(): boolean {
        return this._isOrderUpdateAllowed;
    }

    public set isOrderUpdateAllowed(value: boolean) {
        this._isOrderUpdateAllowed = value;
    }

    override onLoad(): void | Promise<void> {
        this.tableChangeCompareItems.dataSource;
        this.tableChangeCompareItems.dataSource = this.sourceEdiCompareItem;
        this.tableChangeCompareItems.dataSource.data = [];
    }

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
        if (this._compareItems != null)
            this.tableChangeCompareItems.dataSource.setRowsAndMode(DataSourceMode.NONE, this._compareItems);

        if (this._compareItems != null && this._compareItems.length == 0) {
            this.tableChangeCompareItems.visible = false;
        }
    }

    onItemRowDisplay(event: TableRowDisplayEvent) {
        this.baseCompare.isOrderUpdateAllowed = this.isOrderUpdateAllowed;
        this.baseCompare.isCompareHistory = this.isCompareHistory;
        this.baseCompare.setupCheckboxBehavior(event.getTableRow(), this.isOrderUpdateAllowed, false);
    }


    public get isCompareHistory(): boolean {
        return this._isCompareHistory;
    }

    public set isCompareHistory(isCompareHistory: boolean) {
        this._isCompareHistory = isCompareHistory;
    }

}
